/*-----------------------------------------------------------------
- FAQ
-----------------------------------------------------------------*/

export default {
    title: 'FAQ',
};
